const getEmptyArray = (startEl = 1, endEl = 0) => {
  const array = new Array(endEl - startEl + 1)
    .fill(startEl - 1)
    .map((el, i) => el + i + 1);
  return array;
};

export default getEmptyArray;
